import preferencesManager from "../../services/appSettingsManager";

export default {
  namespaced: true,

  state: {},

  getters: {
    getConnectionSettings(state) {
      return preferencesManager.getConnectionSettings ?? {};
    },
  },

  mutations: {
    setConnectionSettings(state, settings) {
      preferencesManager.setConnectionSettings(settings);
    },
  },

  actions: {},
};
